import React from "react";

const Select = props => {
  return (
    <div className="form-group">
      {props.title !== '' ? <label htmlFor={props.name} className="uxf-label"> {props.title} </label> : ""}
      <select
        id={props.name}
        name={props.name}
        tabIndex={props.tabIndex}
        value={props.value}
        onChange={props.handleChange}
        className="form-control"
      >
         {props.defaultValue !== '' ? <option value="">{props.defaultValue}</option> : ""}
        {props.options.map((result) => <option key={result.value} value={result.value}>{result.display}</option>)}
      </select>
    </div>
  );
};
export default Select;